import { SequentialFetchQueue } from './sequential-fetch-queue';
import { fetch, Request } from 'cross-fetch';
const fetchTimeout = 20000;
const queueTimeout = 120000;
export function internalFetch(url, options, callback) {
    const request = new Request(url, options);
    return fetchQueue.add(request, callback);
}
const fetchQueue = new SequentialFetchQueue(fetch, fetchTimeout, queueTimeout);
//# sourceMappingURL=fetch.js.map